module.exports = __webpack_public_path__ + "img/tap.ba68634c.png";